'use strict';

module.exports = {
    Cs: 133,
    Cu: 64,
    Kr: 84,
    Cl: 35,
    Co: 59,
    Cr: 52,
    Li: 7,
    Cd: 112,
    Ce: 140,
    La: 139,
    Lu: 175,
    Tm: 169,
    Ti: 48,
    Te: 128,
    Dy: 162,
    Ta: 181,
    Mg: 24,
    Tc: 98,
    Tb: 159,
    F: 19,
    Fe: 56,
    B: 11,
    C: 12,
    N: 14,
    O: 16,
    H: 1,
    Eu: 152,
    Mo: 96,
    I: 127,
    Mn: 55,
    K: 39,
    Er: 167,
    W: 184,
    V: 51,
    Ni: 59,
    P: 31,
    S: 32,
    Nd: 144,
    Ne: 20,
    Nb: 93,
    Y: 89,
    Na: 23,
    Ge: 73,
    Gd: 157,
    Ga: 70,
    Yb: 173,
    Pt: 195,
    Pr: 141,
    Hf: 178,
    He: 4,
    Pd: 106,
    Ho: 165,
    Pm: 145,
    Xe: 131,
    Os: 190,
    Se: 79,
    Au: 197,
    Sc: 45,
    In: 115,
    Ar: 40,
    Si: 28,
    As: 75,
    Sn: 119,
    Sm: 150,
    Ba: 137,
    Sr: 88,
    Ir: 192,
    Ru: 101,
    Ag: 108,
    Sb: 122,
    Al: 27,
    Rb: 85,
    Re: 186,
    Rh: 103,
    Br: 80,
    Ca: 40,
    Be: 9,
    Zn: 65,
    Zr: 91
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/nominalMass.js
 ** module id = 2
 ** module chunks = 0
 **/